import React from 'react';
import CommonService from '../api-services/CommonService';
class ErrorBoundary extends React.Component {
  constructor(props) {
    super(props);
    this.state = { hasError: false };
  }

  componentDidCatch(error, errorInfo) {
    // Log the error to an error reporting service
    const commonService = new CommonService();
    commonService.logReactErrors(error, 'errorBoundry', '', errorInfo);
    this.setState({
      hasError: true,
    });
  }
  render() {
    return this.props.children;
  }
}
export default ErrorBoundary;
